var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.shouldShow
    ? _c("owa-message", {
        attrs: {
          title: _vm.title,
          content: _vm.content,
          "icon-style": _vm.iconStyle,
          "icon-name": _vm.iconName,
          theme: _vm.theme,
          "has-border": "",
          type: "flash",
        },
        on: { action: _vm.clear },
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }